/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorExternalIDTypename = "PharmacyCounselorExternalID" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorExternalID
 */
export interface PharmacyCounselorExternalID {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorExternalID
   */
  digitalMemberId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorExternalID
   */
  ezocaMemberId?: string;
  /**
   * operator role only
   * @type {string}
   * @memberof PharmacyCounselorExternalID
   */
  gooponId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorExternalID
   */
  netUserId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorExternalID
   */
  qolMemberId?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorExternalID
   */
  readonly __typename?: string;
}

export function PharmacyCounselorExternalIDFromJSON(json: any): PharmacyCounselorExternalID {
  return PharmacyCounselorExternalIDFromJSONTyped(json, false);
}

export function PharmacyCounselorExternalIDFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorExternalID {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorExternalIDTypename,

    digitalMemberId: !exists(json, "digital_member_id") ? undefined : json["digital_member_id"],
    ezocaMemberId: !exists(json, "ezoca_member_id") ? undefined : json["ezoca_member_id"],
    gooponId: !exists(json, "goopon_id") ? undefined : json["goopon_id"],
    netUserId: !exists(json, "net_user_id") ? undefined : json["net_user_id"],
    qolMemberId: !exists(json, "qol_member_id") ? undefined : json["qol_member_id"],
  };
}

export function PharmacyCounselorExternalIDToJSON(object?: PharmacyCounselorExternalID | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    digital_member_id: value.digitalMemberId,
    ezoca_member_id: value.ezocaMemberId,
    goopon_id: value.gooponId,
    net_user_id: value.netUserId,
    qol_member_id: value.qolMemberId,
  };
}
